module.exports = __webpack_public_path__ + "static/media/about.fa2a6dca.jpg";